import { useState } from "react";
import { ButtonCustom } from "../../../components/custom/button-custom";
import { TabCustom, TabsCustom } from "../../../components/custom/tab-custom";
import IconPlus from "../../../components/icons/icon-plus";
import { CountTabResponse } from "../../../models/response/count-tab-response";

interface AdminHeaderProps {
  setShowModalCreate: (value: boolean) => void;
  countTab: CountTabResponse;
  setStatus: (value: number) => void;
}

export const AdminHeader = ({ setShowModalCreate, countTab, setStatus }: AdminHeaderProps) => {
  const [value, setValue] = useState(0);
  const tabs = [
    { id: 1, name: "Đang hoạt động", badge: countTab.active },
    { id: 0, name: "Tạm ngưng", badge: countTab.inactive },
  ];

  const handleChange = (newValue: number) => {
    setValue(newValue);
    setStatus(tabs[newValue].id);
  };

  const handleClick = () => {
    setShowModalCreate(true);
  };

  return (
    <div className="flex items-center justify-between gap-4 flex-wrap" id="tab-menu">
      <div className="flex-shrink-0 gap-4">
        <TabsCustom value={value} onChange={handleChange} lineColor="#1462B0">
          {tabs.map((tab) => (
            <TabCustom
              key={tab.id}
              label={tab.name}
              icon={
                <div
                  className={`${tab.badge > 0 ? "flex" : "hidden"} rounded-full items-center justify-center`}
                  style={{
                    backgroundColor: "#e7f7ff",
                    color: "#125192",
                    fontSize: "12px",
                    width: "34px",
                    height: "20px",
                    fontWeight: "bold",
                  }}
                >
                  {tab.badge > 99 ? "99+" : tab.badge}
                </div>
              }
            />
          ))}
        </TabsCustom>
      </div>
      <div className="flex-shrink-0 w-full sm:w-auto">
        <ButtonCustom type="submit" text="Thêm mới" onClick={() => handleClick()} icon={<IconPlus />} />
      </div>
    </div>
  );
};
